import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface the real error instead of a silent white screen.
    console.error("DietFlix UI crash:", error, info?.componentStack);
    // Best-effort report to the server for diagnostics.
    try {
      const base = process.env.REACT_APP_BACKEND_URL || "";
      fetch(`${base}/api/client-errors`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        keepalive: true,
        body: JSON.stringify({
          message: String(error?.message || error || "Errore imprevisto"),
          stack: String(error?.stack || ""),
          component_stack: String(info?.componentStack || ""),
          url: window.location.href,
          user_agent: navigator.userAgent,
        }),
      }).catch(() => {});
    } catch (_) {}
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.message || "Errore imprevisto";
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-6" data-testid="error-boundary">
        <div className="max-w-md w-full text-center space-y-5 bg-card border rounded-2xl p-8 shadow-sm">
          <img src="/DietFlix-logo.webp" alt="DietFlix" className="h-10 mx-auto" />
          <h1 className="font-heading text-xl font-semibold">Qualcosa è andato storto</h1>
          <p className="text-sm text-muted-foreground">
            Si è verificato un problema imprevisto. I tuoi dati sono al sicuro: riprova a ricaricare la pagina.
          </p>
          <div className="flex gap-2 justify-center pt-1">
            <button
              onClick={this.handleReload}
              className="inline-flex items-center justify-center rounded-lg bg-primary text-primary-foreground h-10 px-5 text-sm font-medium hover:opacity-90 transition-opacity"
              data-testid="error-reload-button"
            >
              Ricarica
            </button>
            <button
              onClick={this.handleHome}
              className="inline-flex items-center justify-center rounded-lg border h-10 px-5 text-sm font-medium hover:bg-muted transition-colors"
              data-testid="error-home-button"
            >
              Torna all'inizio
            </button>
          </div>
          <details className="text-left mt-2">
            <summary className="text-xs text-muted-foreground cursor-pointer">Dettagli tecnici</summary>
            <pre className="mt-2 text-[11px] text-muted-foreground whitespace-pre-wrap break-words max-h-40 overflow-auto">{msg}</pre>
          </details>
        </div>
      </div>
    );
  }
}
